import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { clamp } from 'lodash';
import { DialogComponent } from 'src/app/_shared/components/dialog/dialog.component';
import { ChallengesFacade } from 'src/app/challenges/state/challenges.facade';
import { AnalyticsService } from 'src/app/_core/analytics/analytics.service';

@Component({
  selector: 'app-monthly-dialog',
  templateUrl: './monthly-dialog.component.html',
  styleUrls: ['./monthly-dialog.component.scss']
})
export class MonthlyDialogComponent implements OnInit {
  readonly MIN_VALUE = 1;
  readonly MAX_VALUE = 30;

  private readonly challengesFacade = inject(ChallengesFacade);
  private readonly fb = inject(FormBuilder);
  private readonly analyticsService = inject(AnalyticsService);

  initialValue = signal<number|undefined>(undefined);

  monthlyChallengeFormGroup: FormGroup;

  @ViewChild('dialog') dialog!: DialogComponent;

  get targetControl() {
    return this.monthlyChallengeFormGroup.get('target');
  }

  ngOnInit() {
    this.monthlyChallengeFormGroup = this.fb.group({
      target: new FormControl<number>(1, [Validators.required, Validators.min(1), Validators.max(30)])
    });
  }

  updateInitialValue() {
    this.initialValue.set(this.challengesFacade.initialValue);
    this.targetControl.setValue(this.initialValue() || this.MIN_VALUE);
  }

  createChallenge() {
    this.dialog.closeDialog();

    if (this.initialValue() !== undefined) {
      this.challengesFacade.putUserMonthlyChallenge(this.targetControl.value).subscribe();
    } else {
      this.challengesFacade.postUserMonthlyChallenge(this.targetControl.value).subscribe({
        next: () => this.analyticsService.sendUserActionEvent('monthly_challenge_created', true),
        error: () => this.analyticsService.sendUserActionEvent('monthly_challenge_created', false),
      });
    }
  }

  closeModal() {
    this.monthlyChallengeFormGroup.setValue({ target: this.initialValue() ?? this.MIN_VALUE });
    this.challengesFacade.setInitialValue(undefined);
    this.dialog.closeDialog();
  }

  addTarget() {
    if (this.targetControl.value < this.MAX_VALUE && this.targetControl.value !== '') {
      this.monthlyChallengeFormGroup.controls['target'].setValue(
        Number(this.targetControl.value) + 1
      );
    }
  }

  removeTarget() {
    if (this.targetControl.value > this.MIN_VALUE && this.targetControl.value !== '') {
      this.monthlyChallengeFormGroup.controls['target'].setValue(this.targetControl.value - 1);
    }
  }

  modifyValue() {
    this.monthlyChallengeFormGroup.controls['target'].setValue(this.targetControl.value);
  }

  checkValue() {
    this.monthlyChallengeFormGroup.controls.target.setValue(clamp(this.targetControl.value, this.MIN_VALUE, this.MAX_VALUE))
  }
}
